/**
 * Supabase auth client — sign-in only.
 *
 * Dependency justification (§9 rule 12): the API verifies Supabase-issued JWTs,
 * so the browser has to obtain one. Rolling that by hand means reimplementing
 * token refresh and secure session storage, which is precisely the code you do
 * not want hand-written in front of live financial data. No existing dependency
 * does it.
 *
 * The farm's data is never read through this client — that goes through the
 * Hono API so every figure comes from `packages/costing` (§9 rule 6).
 */
import { createClient } from '@supabase/supabase-js'
import { config } from '../config/env'

export const supabase = createClient(config.supabaseUrl, config.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    // The farm signs in on one laptop and stays signed in for the evening's entry.
    detectSessionInUrl: false,
  },
})
